module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"support":"Support","administration":"Administration","language":"Language","log_out":"Log out","log_in":"Log in"},"fr":{"support":"Soutien","administration":"Administrations","language":"Langue","log_out":"Se déconnecter","log_in":"Connexion"}}')
  delete Component.options._Ctor
}
